import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import PinInput from 'react-pin-input';
import { logoVoxel } from '../../imagepath';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../../services/ApiService.js';
import Loader from '../../../common/loader.jsx';
import { ErrorMessage } from '@hookform/error-message';
import { notification } from 'antd';
import apiService from '../../../axios/apiService';
import { useUser } from '../../../hooks/useUser.js';
import { useUserToken } from '../../../hooks/useToken.js';
import { LOGIN_FORM_TYPES } from '../../../appContants.js';
import AppMascot from './AppMascot.jsx';
import ReverseTimer from '../../../common/ReverseTimer.jsx';

const Login = () => {
  const { setUserToken } = useUserToken();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  // otp
  const [cognitoUser, setCognitoUser] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useUser();
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  let inputRef = useRef();
  const [timerKey, setTimerKey] = useState(0);
  const [formDataForOtp,setFormData] = useState(null);
  const [isOtpTimerActive, setIsOtpTimerActive] = useState(false);

  const CallMe = async () => {
    try {
      let user = await apiService.callme();
      if (user) {
        // Persist user on local storage
        setUser(user);

        navigate('user/admin-dashboard');
      }
    } catch (error) {
      api.error({
        message: error?.message | 'Error',
        description: 'something went wrong!!',
        showProgress: false,
        // pauseOnHover,
      });
      setIsLoading(false);
      // throw error;
    }
  };

  return (
    <>
      {contextHolder}
      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <AppMascot></AppMascot>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="/admin-dashboard">
                          <img
                            src={logoVoxel}
                            alt="#"
                            style={{ height: 130 }}
                          />
                        </Link>
                      </div>
                      <h2>
                        {cognitoUser?.challengeName ===
                        LOGIN_FORM_TYPES.NEW_PASSWORD_REQUIRED
                          ? 'Update Password'
                          : 'Login'}
                      </h2>
                      {/* Form */}
                      {cognitoUser?.challengeName ===
                      LOGIN_FORM_TYPES.NEW_PASSWORD_REQUIRED ? (
                        <form
                          onSubmit={handleSubmit(async (data) => {
                            try {
                              setIsLoading(true);
                              let user = await ApiService.updateNewUserPassword(
                                cognitoUser,
                                data
                              );
                              if (user) {
                                setCognitoUser(user);
                                reset();
                                setIsLoading(false);
                              } else {
                                setIsLoading(false);
                                api.error({
                                  message: 'Error',
                                  description:
                                    'Something is wrong!!',
                                  showProgress: false,
                                });
                              }
                            } catch (error) {
                              setIsLoading(false);
                            }
                          })}
                        >
                          <div className="form-group">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              ref={inputRef}
                              className="form-control pass-input"
                              type={showPassword ? 'text' : 'password'}
                              {...register('password', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.password && <p>Please enter password</p>}
                            </small>
                            <ErrorMessage errors={errors} name="password" />
                            {showPassword ? (
                              <span
                                className="profile-views feather-eye-off toggle-password"
                                onClick={togglePasswordVisibility}
                              >
                                <FeatherIcon icon="eye-off" />
                              </span>
                            ) : (
                              <span
                                className="profile-views feather-eye-off toggle-password"
                                onClick={togglePasswordVisibility}
                              >
                                <FeatherIcon icon="eye" />
                              </span>
                            )}
                          </div>
                          <div className="form-group login-btn">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      ) : cognitoUser?.challengeName ===
                        LOGIN_FORM_TYPES.CUSTOM_CHALLENGE ? (
                        <div className="login-otp-section">
                          {isOtpTimerActive && (
                            <p className="login-otp-message">
                              6-digit code sent to <strong>{formDataForOtp?.email}</strong>.
                              Valid for 2 minutes.
                            </p>
                          )}
                          <PinInput
                              length={6}
                              initialValue=""
                              type="numeric"
                              inputMode="number"
                              style={{ padding: 0, margin: '0 0 16px', width: '100%' }}
                              inputStyle={{
                                width: '48px',
                                height: '48px',
                                margin: 0,
                                padding: 0,
                                fontSize: '20px',
                                fontWeight: 600,
                                textAlign: 'center',
                                border: '2px solid rgba(46, 55, 164, 0.1)',
                                borderRadius: '10px',
                                background: '#fff',
                                color: '#333448',
                              }}
                              inputFocusStyle={{
                                borderColor: 'rgb(74 83 199 / 80%)',
                                outline: 'none',
                                boxShadow: 'none',
                              }}
                              onComplete={async (value) => {
                                if (value.length) {
                                  try {
                                    setIsLoading(true);
                                    let user = await ApiService.authOtpSignIn(
                                      cognitoUser,
                                      value
                                    );
                                    if (user?.signInUserSession) {
                                      setUserToken(
                                        user.signInUserSession.idToken.jwtToken
                                      );
                                      setCognitoUser(user);
                                      CallMe();
                                    } else {
                                      api.error({
                                        message: 'Error',
                                        description: 'Invalid verification code!!',
                                        showProgress: false,
                                      });
                                      setIsLoading(false);
                                    }
                                  } catch (error) {
                                    api.error({
                                      message: 'Error',
                                      description: error,
                                      showProgress: false,
                                    });
                                  }
                                }
                              }}
                              autoSelect={true}
                              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                            />
                          <div className="forgotpass login-otp-actions">
                                <ReverseTimer
                                  key={timerKey} // 👈 ensures re-render when resend succeeds
                                  duration={2 * 60} // 10 minutes
                                  onExpire={() => console.log('Timer expired')}
                                  onResend={async () => {
                                    try {
                                      setIsLoading(true);
                                      const res = await ApiService.logIn(formDataForOtp);
                                      if (res) {
                                        api.success({
                                          message: 'OTP Sent',
                                          description: 'A new OTP has been sent to your registered email/phone.',
                                          showProgress: false,
                                        });

                                        // 👇 Start counter only AFTER success
                                        setTimerKey((prev) => prev + 1);
                                        return true;
                                      }
                                    } catch (err) {
                                      api.error({
                                        message: 'Error',
                                        description: 'Invalid verification code!!',
                                        showProgress: false,
                                      });
                                      return false;
                                    } finally {
                                      setIsLoading(false);
                                    }
                                  }}
                                  onActiveChange={setIsOtpTimerActive}
                                />
                            <Link onClick={() => setCognitoUser(null)}>Back To Login</Link>
                          </div>
                        </div>
                      ) : (
                        <form
                          onSubmit={handleSubmit(async (data) => {
                            try {
                              setIsLoading(true);
                              let user = await ApiService.logIn(data);
                              if (user) {
                                setFormData(data);
                                setCognitoUser(user);
                                reset();
                                setIsLoading(false);
                              } else {
                                setIsLoading(false);
                                api.error({
                                  message: 'Error',
                                  description:
                                    'Your username or password is wrong!!',
                                  showProgress: false,
                                });
                              }
                            } catch (error) {
                              setIsLoading(false);
                            }
                          })}
                        >
                          <div className="form-group">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              {...register('email', {
                                required: 'Please Enter Your Email!',
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: 'Please Enter A Valid Email!',
                                },
                              })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.email?.message}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              ref={inputRef}
                              className="form-control pass-input"
                              type={showPassword ? 'text' : 'password'}
                              {...register('password', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.password && <p>Please enter Password</p>}
                            </small>
                            <ErrorMessage errors={errors} name="password" />
                            {showPassword ? (
                              <span
                                className="profile-views feather-eye-off toggle-password"
                                onClick={togglePasswordVisibility}
                              >
                                <FeatherIcon icon="eye-off" />
                              </span>
                            ) : (
                              <span
                                className="profile-views feather-eye-off toggle-password"
                                onClick={togglePasswordVisibility}
                              >
                                <FeatherIcon icon="eye" />
                              </span>
                            )}
                          </div>
                          <div className="forgotpass">
                            <Link to="/forgotpassword">Forgot Password?</Link>
                          </div>
                          <div className="form-group login-btn">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      )}
                      {/* <div className="next-sign">
                        <p className="account-subtitle">
                          Have You Register Your Clinic?{' '}
                          <Link to="/signup">Sign Up</Link>
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default Login;
